module.exports = "./static/ico_empty.8940cb9b.png";